export const koreanRegex = /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]*$/;
export const numberRegex = /^[0-9]*$/;
export const hyphenNumberRegex = /^[0-9-]*$/;
